<template>
  <div class="main-bg has-aside-main-bg training-plan">
    <page-header title="培养计划" :data="pageHeaderArr" />
    <div v-if="isShowPlan" class="plan-content">
      <div class="divider">
        <div class="item">
          <label for="">要求必修课总学分：</label>
          <span>{{ requireCourseData.requireScore }}</span>
        </div>
        <div class="item">
          <label for="">已修必修课学分：</label>
          <span size="small">{{ requireCourseData.finishScore }}</span>
        </div>
      </div>
      <ming-table v-model="requireCourseData.courseInfo" :fields="column">
        <template #isGPA="{ scope }">
          {{ +scope.isGPA ? '是' : '否' }}
        </template>
        <template v-for="(item, k) in semesterCountData" #[`aaa${item-1}`]="{ scope }">
          <!-- {{ +item === +scope.semester ? 'dui' : '-' }} -->

          <i v-if="item === +scope.semester" :key="k" class="el-icon-check" style="color: var(--theme-color); font-weight: bold; font-size: 20px"></i>
          <span v-else :key="k">-</span>
        </template>
      </ming-table>

      <div class="divider">
        <div class="item">
          <label>选修课列表</label>
        </div>
        <div class="item">
          <label for="">要求选修课最低学分：</label>
          <span>{{ electiveCourseData.requireScore }}</span>
        </div>
        <div class="item">
          <label for="">已选选修课学分：</label>
          <span size="small">{{ electiveCourseData.selectedScore || 0 }}</span>
        </div>

        <div class="item">
          <label for="">已修选修课学分：</label>
          <span size="small">{{ electiveCourseData.finishScore }}</span>
        </div>
      </div>
      <ming-table v-model="electiveCourseData.courseInfo" :fields="column">
        <template #isGPA="{ scope }">
          {{ +scope.isGPA ? '是' : '否' }}
        </template>
        <template v-for="item in semesterCountData" #[`aaa${item-1}`]="{ scope }">
          {{ +item === +scope.semester ? '是' : '-' }}
        </template>
      </ming-table>
      <div class="divider">
        <h5>培养计划备注信息</h5>
      </div>
      <div class="remarks" style="white-space: pre-line">
        {{ remarkData || '暂无备注信息' }}
      </div>
    </div>
    <div v-else class="plan-empty">
      <img src="@/assets/text-empty.png" alt="" />
      <span>暂无相关数据</span>
    </div>
  </div>
</template>

<script setup>
import { planTableOne } from './tableColumn'
import PageHeader from '@/components/PageHeader'
import { ref, onMounted, computed } from 'vue'
import API from '@/api'
import Store from '@/store'

const column = ref([])

const userInfo = computed(() => {
  return Store.state.user.userInfo
})

const requireCourseData = ref({})
const remarkData = ref('')
const semesterCountData = ref(null)
const electiveCourseData = ref({})

const isShowPlan = ref(false)

// 阿拉伯数字转大写，整数转大写
const numToCapital = (num, type = '') => {
  if (!num) return 0
  const strNum = Number((num + '').replace(/[,，]*/g, '')) + '' // 记录字符
  num = parseInt(Number(strNum)) // 转为整数，
  let capitalAr = '零一二三四五六七八九十'
  let unitAr = ['十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千']
  if (type) {
    capitalAr = '零壹贰叁肆伍陆柒捌玖拾'
    unitAr = ['拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'] // 单位
  }
  const resultAr = [] // 记录结果，后边json.in就可
  const index = strNum.length - 1 // 记录位数
  let idx = 0 // 记录单位
  const percent = 10
  const turnNum = (num, percent, index) => {
    const unit = num / percent
    const capital = capitalAr[Number(strNum[index])]
    if (unit < 1) {
      resultAr.push(capital)
      // 出现11【一十一】这种情况
      if (Number(strNum[index]) === 1 && (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)) {
        resultAr.pop()
      }
      return false // 结束递归
    } else {
      if (capital === '零') {
        // 万和亿单位不删除
        if (!['万', '亿'].includes(resultAr[resultAr.length - 1])) {
          resultAr.pop()
        }
        // 前面有零在删掉一个零
        if (resultAr[resultAr.length - 1] === '零') {
          resultAr.pop()
        }
      }
      resultAr.push(capital)
      // 过滤存在【零万】【零亿】这种情况
      if (['万', '亿'].includes(resultAr[resultAr.length - 2]) && capital === '零') {
        resultAr.pop()
      }
      // 过滤【1亿万】这种情况
      if (resultAr[0] === '万' && resultAr[1] === '亿') {
        resultAr.shift()
      }
      // 末尾【零】删掉
      if (resultAr[0] === '零') {
        resultAr.pop()
      }
      resultAr.push(unitAr[idx++])
      turnNum(num, percent * 10, --index)
    }
  }
  turnNum(num, percent, index)
  return resultAr.reverse().join('')
}

function getUserPlan() {
  const tableColumn = JSON.parse(JSON.stringify(planTableOne))
  API.MBAUserPlan().then(res => {
    if (+res.code === 200 && res.data) {
      const { requireCourse, remark, semesterCount, electiveCourse } = res.data
      for (let index = 0; index < semesterCount; index++) {
        const element = {
          label: `第${numToCapital(index + 1)}学期`,
          field: `aaa${index}`,
          slot: true
        }
        tableColumn.splice(5 + index, 0, element)
      }
      column.value = tableColumn
      semesterCountData.value = semesterCount
      requireCourseData.value = requireCourse
      remarkData.value = remark
      electiveCourseData.value = electiveCourse
      isShowPlan.value = true
    } else {
      isShowPlan.value = false
    }
  })
}

const pageHeaderArr = ref([
  {
    title: '学号',
    value: userInfo.value.idnumber || '-'
  },
  {
    title: ' 班级',
    value: userInfo.value.className || '-'
  }
])

onMounted(() => {
  getUserPlan()
})
</script>

<style lang="scss" scoped>
.remarks {
  // border: 1px solid #E9E9E9;
  // padding: 13px 20px 39px 20px;
  box-sizing: border-box;
  font-size: 16px;
  color: #333333;
  line-height: 36px;
  font-size: 14px;
}
:deep(.el-divider--horizontal > .el-divider__text) {
  background-color: var(--layout-background);
}
:deep(.el-descriptions__body) {
  background: none;
}
.divider {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
  label {
    color: #666666;
    font-size: 16px;
    font-weight: 500;
  }
  span {
    color: var(--theme-color);
    font-weight: 600;
  }
  .item:not(:last-child) {
    margin-right: 10px;
  }
  h5 {
    font-size: 16px;
    color: #666666;
    font-weight: 500;
  }
  margin-top: 20px;
}
.training-plan {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .plan-empty {
    width: 100%;
    height: calc(100vh - 400px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 172px;
      height: 172px;
    }
    span {
      color: #ddd;
    }
  }
}
</style>
